// Styled Components
import styled from "styled-components";

// Material UI
// import AddIcon from "@mui/icons-material/Add";
import { Add } from "@material-ui/icons";

const GenerateItemsItem = () => {
  return (
    <Wrapper>
      <Add className="icon" />
    </Wrapper>
  );
};

export default GenerateItemsItem;

const Wrapper = styled.div`
  //
  width: 200px;
  @media only screen and (max-width: 475px) {
    width: 100%;
  }
  //

  border: 2px solid #fff;

  //
  height: 200px;
  @media only screen and (max-width: 400px) {
    height: 150px;
  }
  //

  background-color: #000;

  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    font-size: 5rem;
    fill: #fff;
    color: #fff;
  }
`;
